import { CountryCodes } from '../../emun/CountryCodes'
import {
  RUSSIA,
  KAZAKHSTAN,
  LITHUANIA,
  LATVIA,
  ESTONIA,
  MOLDOVA,
  ARMENIA,
  BELARUS,
  TAJIKISTAN,
  TURKMENISTAN,
  AZERBAIJAN,
  GEORGIA,
  KYRGYZSTAN,
  UZBEKISTAN,
  TEST,
} from './countriesInfo'

export interface IValidationOption {
  countryCode: CountryCodes
  mask: string
}

const ruCommonOptions = [
  {
    countryCode: CountryCodes[RUSSIA],
    mask: '+7 9## #######',
  },
]

const commonOptions = [
  ...ruCommonOptions,
  {
    countryCode: CountryCodes[KAZAKHSTAN],
    mask: '+7 6## #######',
  },
  {
    countryCode: CountryCodes[KAZAKHSTAN],
    mask: '+7 7## #######',
  },
  {
    countryCode: CountryCodes[LITHUANIA],
    mask: '+370 # #######',
  },
  {
    countryCode: CountryCodes[LATVIA],
    mask: '+371 ## ######',
  },
  {
    countryCode: CountryCodes[ESTONIA],
    mask: '+372 ## #####',
  },
  {
    countryCode: CountryCodes[ESTONIA],
    mask: '+372 5 ######',
  },
  {
    countryCode: CountryCodes[MOLDOVA],
    mask: '+373 ### #####',
  },
  {
    countryCode: CountryCodes[ARMENIA],
    mask: '+374 ## ######',
  },
  {
    countryCode: CountryCodes[BELARUS],
    mask: '+375 ## #######',
  },
  {
    countryCode: CountryCodes[TAJIKISTAN],
    mask: '+992 ## #######',
  },
  {
    countryCode: CountryCodes[TURKMENISTAN],
    mask: '+993 6 #######',
  },
  {
    countryCode: CountryCodes[TURKMENISTAN],
    mask: '+993 ## ######',
  },
  {
    countryCode: CountryCodes[AZERBAIJAN],
    mask: '+994 ## #######',
  },
  {
    countryCode: CountryCodes[GEORGIA],
    mask: '+995 ### ######',
  },
  {
    countryCode: CountryCodes[GEORGIA],
    mask: '+995 220 #####',
  },
  {
    countryCode: CountryCodes[KYRGYZSTAN],
    mask: '+996 ### ######',
  },
  {
    countryCode: CountryCodes[UZBEKISTAN],
    mask: '+998 ## #######',
  },
]

const autotestOptions = [
  {
    countryCode: CountryCodes[TEST],
    mask: '+70# ### #####',
  },
  {
    countryCode: CountryCodes[TEST],
    mask: '+80# ### #####',
  },
]

export const PROD_VALIDATION_OPTIONS = commonOptions
export const RU_PROD_VALIDATION_OPTIONS = ruCommonOptions
export const DEV_RC_VALIDATION_OPTIONS = [...commonOptions, ...autotestOptions]
export const RU_DEV_RC_VALIDATION_OPTIONS = [...ruCommonOptions, ...autotestOptions]
